import axios from 'axios';
import { get } from 'lodash';
import { BASE_URL } from 'config/env';
import { SuccessHandler } from 'apiClient/successHandler';
import { ErrorHandler } from 'apiClient/errorHandler';
import { apiHeaders, removeHeaders } from 'apiClient/authorization';

let TIMEOUT = 60000;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  validateStatus: status => status >= 200 && status < 300,
});

const requestHandler = request => {
  return request;
};

const fireRequest = async (method, url, data, requestOptions) => {
  // requestOptions = requestOptions || {};
  let headers = await apiHeaders(requestOptions.ifFormData);
  TIMEOUT = url === 'sendJobApplication.json' ? 50000 : TIMEOUT;
  const options = {
    method,
    data: (method === 'POST' && data) || (method === 'PUT' && data),
    timeout: TIMEOUT,
    headers: headers,
    params: get(data, 'params', undefined),
  };
  try {
    axiosInstance.interceptors.request.use(request => requestHandler(request));
    axiosInstance.interceptors.response.use(
      response => {
        if (response && response.data.status === '401') {
          removeHeaders();
          fireRequest(method, url, data, requestOptions);
        } else {
          return SuccessHandler(response);
        }
      },
      error => ErrorHandler(error)
    );
    return await axiosInstance(url, options);
  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  get(url, data, options) {
    return fireRequest('GET', url, data, options || {});
  },

  post(url, data, options) {
    return fireRequest('POST', url, data, options || {});
  },

  put(url, data, options) {
    return fireRequest('PUT', url, data, options || {});
  },

  delete(url, data, options) {
    return fireRequest('DELETE', url, data, options || {});
  },

  axios() {
    return axiosInstance;
  },
};
